<template>
  <div>
    <validation-observer ref="observer">
      <base-container has-title
                    title="檢核項目"
                    style="padding-top:10px">
        <table class="table table-bordered  ">
          <tbody>
            <tr>
              <th style="width: 20%">項目</th>
              <th :style="styleWidth?'width: 30%':'width: 10%'"> 發查結果</th>
              <th style="width: 40%">說明</th>
            </tr>
            <tr>
              <td>要保人三個月內是否保單解約和保單借款</td>
              <td>{{checkItemList.plResult}}</td>
              <td></td> <!-- 固定空白 -->
            </tr>
            <tr>
              <td>地址、手機、電話和信箱檢核(業代)</td>
              <td>{{checkItemList.agResult}}</td>
              <!-- 不通過，'+。+ValidateAddr+。+ValidateRegAddr+。+ValidateTel+。+ValidateMobile+。+ValidateEmail。 -->
              <td v-if="checkItemList.polvdMap.AG">
                <b-textarea placeholder="客戶地址、手機、電話和信箱同業務員或進件單位，請檢附身分證明文件、親屬證明、同住證明或戶口名簿..等。"
                            v-model="checkItemList.polvdMap.AG[0].itemDesc"
                            maxlength="200"
                            rules="required"
                            vname="地址、手機、電話和信箱檢核(業代)說明"
                            vid="textareaAG"
                            :disabled="isPreview"
                            outline></b-textarea>
                <validation-observer v-slot="{errors}">
                  <upload-input ref="filesAG"
                                v-model="filesAG"
                                :filesUpd="filesAG"
                                :file-type="'AG'"
                                :is-preview="isPreview"
                                @file-picker="onfilePickerLog"
                                @upload="onUpload"
                                @delete="onDelete"
                                ></upload-input>
                  <error-messages style="margin-top: 0px;" :value="errorsHandler(errors)"></error-messages>
                  <validation-provider name="地址、手機、電話和信箱檢核(業代)"
                                        vid="filesAG"
                                        :rules="(isPreview) ? '' : 'uploadRequired'"
                                        :immediate="filesAG.length>0">
                    <input :value="filesAG[0]" style="height:0;width:0;" id="filesAG" />
                  </validation-provider>
                </validation-observer>
              </td> <td v-else></td>
            </tr>
            <tr>
              <td>集中度檢核-地址</td>
              <td>{{checkItemList.caResult}}</td>
              <td v-if="checkItemList.polvdMap.CA">
                <div v-for="(item, index) in checkItemList.polvdMap.CA" :key="index">
                  {{item.itemName}}
                  <b-textarea placeholder="王大明為要保人之配偶、王小明為要保人之兒子…等。"
                              v-model="checkItemList.polvdMap.CA[index].itemDesc"
                              maxlength="200"
                              :disabled="isPreview"
                              rules="required"
                              vname="集中度檢核-地址"
                              :vid="'textarea' + index + 'CA'"
                              outline></b-textarea>
                </div>
                <validation-observer v-slot="{errors}">
                  <upload-input  ref="filesCA"
                                v-model="filesCA"
                                :filesUpd="filesCA"
                                :file-type="'CA'"
                                :is-preview="isPreview"
                                @file-picker="onfilePickerLog"
                                @upload="onUpload"
                                @delete="onDelete"
                                ></upload-input>
                  <input :value="filesCA[0]" style="height:0;width:0;" id="filesCA" />
                  <error-messages style="margin-top: 0px;" :value="errorsHandler(errors)"></error-messages>
                </validation-observer>
              </td> <td v-else></td>
              </tr>
              <tr>
              <td>集中度檢核-戶籍地址</td>
              <td>{{checkItemList.crResult}}</td>
                <td v-if="checkItemList.polvdMap.CR">
                <div v-for="(item, index) in checkItemList.polvdMap.CR" :key="index">
                  {{item.itemName}}
                  <b-textarea placeholder="王大明為要保人之配偶、王小明為要保人之兒子…等。"
                              v-model="checkItemList.polvdMap.CR[index].itemDesc"
                              maxlength="200"
                              :disabled="isPreview"
                              rules="required"
                              vname="集中度檢核-戶籍地址說明"
                              :vid="'textarea' + index + 'CR'"
                              outline></b-textarea>
                </div>
                <validation-observer v-slot="{errors}">
                  <upload-input ref="filesCR"
                                v-model="filesCR"
                                :filesUpd="filesCR"
                                :file-type="'CR'"
                                :is-preview="isPreview"
                                @file-picker="onfilePickerLog"
                                @upload="onUpload"
                                @delete="onDelete"
                                ></upload-input>
                  <input :value="filesCR[0]" style="height:0;width:0;" id="filesCR" />
                  <error-messages style="margin-top: 0px;" :value="errorsHandler(errors)"></error-messages>
                </validation-observer>
              </td> <td v-else></td>
            </tr>
            <tr>
              <td class="w40">集中度檢核-手機</td>
              <td>{{checkItemList.cmResult}}</td>
              <td v-if="checkItemList.polvdMap.CM">
                <div v-for="(item, index) in checkItemList.polvdMap.CM" :key="index">
                  {{item.itemName}}
                  <b-textarea placeholder="王大明為要保人之配偶、王小明為要保人之兒子…等。"
                              v-model="checkItemList.polvdMap.CM[index].itemDesc"
                              maxlength="200"
                              rules="required"
                              vname="客戶地址、手機、電話和信箱同業務員或進件單位說明"
                              :vid="'textarea' + index + 'CM'"
                              :disabled="isPreview"
                              outline></b-textarea>
                </div>
                <validation-observer v-slot="{errors}">
                  <upload-input ref="filesCM"
                                v-model="filesCM"
                                :filesUpd="filesCM"
                                :file-type="'CM'"
                                :is-preview="isPreview"
                                @file-picker="onfilePickerLog"
                                @upload="onUpload"
                                @delete="onDelete"
                                ></upload-input>
                  <input :value="filesCM[0]" style="height:0;width:0;" id="filesCM" />
                  <error-messages style="margin-top: 0px;" :value="errorsHandler(errors)"></error-messages>
                </validation-observer>
              </td> <td v-else></td>
            </tr>
            <tr>
              <td>集中度檢核-電話</td>
              <td>{{checkItemList.ctResult}}</td>
              <td v-if="checkItemList.polvdMap.CT">
                <div v-for="(item, index) in checkItemList.polvdMap.CT" :key="index">
                  {{item.itemName}}
                  <b-textarea placeholder="王大明為要保人之配偶、王小明為要保人之兒子…等。"
                              v-model="checkItemList.polvdMap.CT[index].itemDesc"
                              maxlength="200"
                              rules="required"
                              vname="集中度檢核-電話說明"
                              :vid="'textarea' + index + 'CT'"
                              :disabled="isPreview"
                              outline></b-textarea>
                </div>
                <validation-observer v-slot="{errors}">
                  <upload-input ref="filesCT"
                                v-model="filesCT"
                                :filesUpd="filesCT"
                                :file-type="'CT'"
                                :is-preview="isPreview"
                                @file-picker="onfilePickerLog"
                                @upload="onUpload"
                                @delete="onDelete"
                                ></upload-input>
                  <input :value="filesCT[0]" style="height:0;width:0;"  id="filesCT" />
                  <error-messages style="margin-top: 0px;" :value="errorsHandler(errors)"></error-messages>
                </validation-observer>
              </td> <td v-else></td>
            </tr>
            <tr>
              <td class="w40">集中度檢核-信箱</td>
              <td>{{checkItemList.ceResult}}</td>
              <td v-if="checkItemList.polvdMap.CE">
                <div v-for="(item, index) in checkItemList.polvdMap.CE" :key="index">
                  {{item.itemName}}
                  <b-textarea placeholder="王大明為要保人之配偶、王小明為要保人之兒子…等。"
                              v-model="checkItemList.polvdMap.CE[index].itemDesc"
                              rules="required"
                              vname="集中度檢核-信箱說明"
                              :vid="'textarea' + index + 'CE'"
                              :disabled="isPreview"
                              outline></b-textarea>
                </div>
                <validation-observer v-slot="{errors}">
                <upload-input ref="filesCE"
                                v-model="filesCE"
                              :filesUpd="filesCE"
                              :file-type="'CE'"
                              :is-preview="isPreview"
                              @file-picker="onfilePickerLog"
                              @upload="onUpload"
                              @delete="onDelete"
                              ></upload-input>
                  <input :value="filesCE[0]" style="height:0;width:0;" id="filesCE"/>
                  <error-messages style="margin-top: 0px;" :value="errorsHandler(errors)"></error-messages>
                </validation-observer>
              </td> <td v-else></td>
            </tr>
          </tbody>
        </table>
      </base-container>

      <base-container has-title
                    v-if="finStatus && checkItemList.cusItem"
                    title="財務狀況-要保人"
                    style="padding-top:10px">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <th style="width: 20%">項目</th>
              <th style="width: 20%">前次</th>
              <th style="width: 20%">本次</th>
              <th>異動原因</th>
            </tr>
            <tr>
              <td class="required">工作年收入(萬元)</td>
              <td>{{ checkItemList.cusItem.O.salaryLast }}</td>
              <td>{{ checkItemList.cusItem.O.salary }}</td>
              <td>
                <b-textarea placeholder="請輸入"
                                :disabled="isPreview || !needSalaryOReason() "
                                v-model="checkItemList.cusItem.O.salaryReason"
                                :rules="(needSalaryOReason() )?'required':''"
                                vname="異動原因"
                                vid="salaryOReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-textarea>
              </td>
            </tr>
            <tr>
              <td class="required">其他收入(萬元)</td>
              <td>{{ checkItemList.cusItem.O.oIncomeLast }}</td>
              <td>{{ checkItemList.cusItem.O.oIncome }}</td>
              <td>
                <b-textarea placeholder="請輸入"
                                :disabled="isPreview || !needOInComeOReason() "
                                v-model="checkItemList.cusItem.O.oIncomeReason"
                                :rules="(needOInComeOReason())?'required':''"
                                vname="異動原因"
                                vid="oIncomeOReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-textarea>
              </td>
            </tr>
            <tr>
              <td class="required">家庭年收入(萬元)</td>
              <td>{{ checkItemList.cusItem.O.hIncomeLast }}</td>
              <td>{{ checkItemList.cusItem.O.hIncome }}</td>
              <td>
                <b-textarea placeholder="請輸入"
                                :disabled="isPreview || !needHInComeOReason() "
                                v-model="checkItemList.cusItem.O.hIncomeReason"
                                :rules="(needHInComeOReason() )?'required':''"
                                vname="異動原因"
                                vid="hIncomeOReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-textarea>
              </td>
            </tr>
            <tr>
              <td class="required">總資產_動產(萬元)</td>
              <td  rowspan="2">{{ checkItemList.cusItem.O.assetsLast }}</td>
              <td >{{ checkItemList.cusItem.O.pp }}</td>
              <td rowspan="2">
                <b-textarea placeholder="請輸入"
                                :disabled="isPreview || !needAssetsOReason()"
                                v-model="checkItemList.cusItem.O.assetsReason"
                                :rules="(needAssetsOReason() )?'required':''"
                                vname="異動原因"
                                vid="assetsOReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-textarea>
              </td>
            </tr>
            <tr>
              <td class="required">總資產_不動產(萬元)</td>
              <td  >{{ checkItemList.cusItem.O.rp }}</td>
            </tr>
          </tbody>
        </table>
      </base-container>

      <base-container has-title
                    v-if="finStatus && checkItemList.cusItem"
                    title="財務狀況-被保人"
                    style="padding-top:10px">
      <table class="table table-bordered  ">
          <tbody>
            <tr>
              <th style="width: 20%">項目</th>
              <th style="width: 20%">前次</th>
              <th style="width: 20%">本次</th>
              <th>異動原因</th>
            </tr>
            <tr>
              <td class="required">工作年收入(萬元)</td>
              <td>{{ checkItemList.cusItem.I.salaryLast }}</td>
              <td>{{ checkItemList.cusItem.I.salary }}</td>
              <td>
                <b-textarea placeholder="請輸入"
                                :disabled="isPreview || !needSalaryIReason()"
                                v-model="checkItemList.cusItem.I.salaryReason"
                                :rules="(needSalaryIReason() )?'required':''"
                                vname="異動原因"
                                vid="salaryIReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-textarea>
              </td>
            </tr>
            <tr>
              <td class="required">其他收入(萬元)</td>
              <td>{{ checkItemList.cusItem.I.oIncomeLast }}</td>
              <td>{{ checkItemList.cusItem.I.oIncome }}</td>
              <td>
                <b-textarea placeholder="請輸入"
                                :disabled="isPreview || !needOInComeIReason() "
                                v-model="checkItemList.cusItem.I.oIncomeReason"
                                :rules="(needOInComeIReason() )?'required':''"
                                vname="異動原因"
                                vid="assetsIReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-textarea>
              </td>
            </tr>
            <tr>
              <td class="required">家庭年收入(萬元)</td>
              <td>{{ checkItemList.cusItem.I.hIncomeLast }}</td>
              <td>{{ checkItemList.cusItem.I.hIncome }}</td>
              <td>
                <b-textarea placeholder="請輸入"
                                :disabled="isPreview || !needHInComeIReason() "
                                v-model="checkItemList.cusItem.I.hIncomeReason"
                                :rules="(needHInComeIReason() )?'required':''"
                                vname="異動原因"
                                vid="assetsIReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-textarea>
              </td>
            </tr>
            <tr>
              <td class="required">總資產_動產(萬元)</td>
              <td  rowspan="2">{{ checkItemList.cusItem.I.assetsLast }}</td>
              <td >{{ checkItemList.cusItem.I.pp }}</td>
              <td rowspan="2">
                <b-textarea placeholder="請輸入"
                                :disabled="isPreview || !needAssetsIReason() "
                                v-model="checkItemList.cusItem.I.assetsReason"
                                :rules="(needAssetsIReason() )?'required':''"
                                vname="異動原因"
                                vid="assetsIReason"
                                maxlength="100"
                                mode="lazy"
                                outline></b-textarea>
              </td>
            </tr>
            <tr>
              <td class="required">總資產_不動產(萬元)</td>
              <td >{{ checkItemList.cusItem.O.rp }}</td>
            </tr>
          </tbody>
        </table>
      </base-container>
    </validation-observer>
  </div>
</template>
<script>
import UploadInput from '@/components/Ins/Policy/UploadInput.vue'
export default {
  name: 'check-item',
  components: { UploadInput },

  props: {
    insFileLimit: {
      type: Number
    },
    initData: {
      type: Object
    },
    initFileItem: {
      type: Array
    },
    isPreview:{
      type: Boolean,
      default: false
    },
    tabStep:{
      type: String
    },
    finStatus:{ // 顯示財務狀況區塊
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      filesAG: [], // 地址、手機、電話和信箱檢核
      filesCA: [], // 集中度檢核-地址
      filesCR: [], // 集中度檢核-戶籍地址
      filesCM: [], // 集中度檢核-手機
      filesCT: [], // 集中度檢核-電話
      filesCE: [], // 集中度檢核-信箱
      checkItemList: {
        plResult: null, // 要保人三個月內是否保單解約和保單借款
        agResult: null, // 地址、手機、電話和信箱檢核
        caResult: null, // 集中度檢核-地址
        ceResult: null, // 集中度檢核-戶籍地址
        cmResult: null, // 集中度檢核-手機
        ctResult: null, // 集中度檢核-電話
        crResult: null, // 集中度檢核-信箱
        polvdMap: { //詳細資料列表
          AG: null,
          CA: null,
          CR: null,
          CM: null,
          CT: null,
          CE: null,
        }
      },
      fileItem: null,  // 檔案列表
    }
  },
  watch: {
    initData: { // 來源資料 (輸入框)
      handler (v) {
         this.checkItemList = { ...this.checkItemList, ...v }
      },
      immediate: true,
      deep: true
    },
    initFileItem: { // 來源資料 (檔案列表)
      handler (v) {
        this.fileItem = v
      }
    },
    fileItem: { // 已上傳檔案列表，全撈之後再分類
      handler (v) {
        if (v) {
          this.filesAG = []
          this.filesCA = []
          this.filesCR = []
          this.filesCM = []
          this.filesCT = []
          this.filesCE = []
          if(v.length > 0) {
            for (let idx in v) {
              let polf = v[idx]
              polf.name = polf['fileName']
              switch (polf['fileType']) {
                case 'AG':
                  this.filesAG.push(polf)
                  break
                case 'CA':
                  this.filesCA.push(polf)
                  break
                case 'CR':
                  this.filesCR.push(polf)
                  break
                case 'CM':
                  this.filesCM.push(polf)
                  break
                case 'CT':
                  this.filesCT.push(polf)
                  break
                case 'CE':
                  this.filesCE.push(polf)
                  break
              }
            }
          }
          this.$emit('update-file-item', v)
        }
      },
      immediate: true,
      deep: true
    },
    checkItemList: { // 將資料傳到父元件，投保流程 暫存用
      handler (v) {
        if (v) { //  同步帶入至「被保人」相對應欄位，清空時也需同步
          if (v.cusItem && v.cusItem.I && "1" === v.cusItem.I.relationOwnerCode) {
            v.cusItem.I.oIncomeReason = v.cusItem.O.oIncomeReason
            v.cusItem.I.hIncomeReason = v.cusItem.O.hIncomeReason
            v.cusItem.I.assetsReason = v.cusItem.O.assetsReason
            v.cusItem.I.salaryReason = v.cusItem.O.salaryReason
          }
          this.$emit('input', v)
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    styleWidth () { // 依據字數長度，修改寬度
      let width = false
      if ( this.checkItemList.agResult && this.checkItemList.agResult.length > 10 ) {
        width = true
      }
      return  width
    }

  },
  methods: {
    resetHandler () { // 全部清除
      if(this.checkItemList.polvdMap){
        Object.values(this.checkItemList.polvdMap).forEach(key => {
          key.forEach(item => {
            item.itemDesc = null
          })
        })
      }
      if(this.checkItemList.polvdMap.AG){
        this.$refs['filesAG'].onResetfile()
      }
      if(this.checkItemList.polvdMap.CA){
        this.$refs['filesCA'].onResetfile()
        }
      if(this.checkItemList.polvdMap.CR){
        this.$refs['filesCR'].onResetfile()
      }
      if(this.checkItemList.polvdMap.CM){
        this.$refs['filesCM'].onResetfile()
      }
      if(this.checkItemList.polvdMap.CT){
        this.$refs['filesCT'].onResetfile()
      }
      if(this.checkItemList.polvdMap.CE){
        this.$refs['filesCE'].onResetfile()
      }
      this.$reset('observer')
    },
    nextStepHandler () {
      if (!this.isPreview) {
        this.doValidate(true)
      }
      // if (this.changedFlag) {
      //   result.changedFlag = this.changedFlag
      // }
      // this.$changedReset()
      this.$emit('next-tab', this.checkItemList)
    },
    audit () { // 查詢頁 視窗 送審
      this.$doValidate('observer').then(isValid => {
        if (isValid) {
          this.$emit('audit',this.checkItemList)
        }
      })
    },
    searchPageTempSave () { // 查詢頁 視窗 暫存
      this.$emit('temp-save',this.checkItemList)
    },
    onUpload (updFileObj) { // 上傳
      this.$emit('upload-file',updFileObj)
    },
    onDelete (fileCode) { // 刪除
      this.$emit('delete-file',fileCode)
    },
    onfilePickerLog () {
      this.$emit('file-picker')
    },
    errorsHandler (errors) {
      const errorsArray = this.$errorMsgHandler(errors)
      return errorsArray
    },
    doValidate (setDoneFlag) {
      this.$doValidate('observer').then(isValid => {
        if (!isValid) {
          let num = this.$validateNum('observer')
          this.$emit('set-validate-num', { step: this.tabStep, num })
          this.$emit('set-tab-done', this.tabStep, false)
        } else {
          this.$emit('set-validate-num', { step: this.tabStep, num: 0 })
          if (setDoneFlag) {
            this.$emit('set-tab-done', this.tabStep, true)
          }
        }
      })
    },
    needSalaryOReason () {
      if (this.checkItemList.cusItem && this.checkItemList.cusItem.O.salaryLast) {
        if (parseFloat(this.checkItemList.cusItem.O.salaryLast) !== parseFloat(this.checkItemList.cusItem.O.salary)){
          return true
        }
      }
      this.checkItemList.cusItem.O.salaryReason = ''
      return false
    },
    needOInComeOReason () {
      if (this.checkItemList.cusItem && this.checkItemList.cusItem.O.oIncomeLast) {
        if (parseFloat(this.checkItemList.cusItem.O.oIncomeLast) !== parseFloat(this.checkItemList.cusItem.O.oIncome)){
          return true
        }
      }
      this.checkItemList.cusItem.O.oIncomeReason = ''
      return false
    },
    needHInComeOReason () {
      if (this.checkItemList.cusItem && this.checkItemList.cusItem.O.hIncomeLast) {
        if (parseFloat(this.checkItemList.cusItem.O.hIncomeLast) !== parseFloat(this.checkItemList.cusItem.O.hIncome)){
          return true
        }
      }
      this.checkItemList.cusItem.O.hIncomeReason = ''
      return false
    },
    needAssetsOReason () {
      if (this.checkItemList.cusItem && this.checkItemList.cusItem.O.assetsLast) {
        if (parseFloat(this.checkItemList.cusItem.O.assetsLast) !== (parseFloat(this.checkItemList.cusItem.O.pp) + parseFloat(this.checkItemList.cusItem.O.rp))){
          return true
        }
      }
      this.checkItemList.cusItem.O.assetsReason = ''
      return false
    },
    needSalaryIReason () {
      if (this.checkItemList.cusItem.I && this.checkItemList.cusItem.I.salaryLast ) {
        if( '1' === this.checkItemList.cusItem.I.relationOwnerCode) {
          return false
        }
        if (parseFloat(this.checkItemList.cusItem.I.salaryLast) !== parseFloat(this.checkItemList.cusItem.I.salary)){
          return true
        }
      }
      this.checkItemList.cusItem.I.salaryReason = ''
      return false
    },
    needOInComeIReason () {
      if (this.checkItemList.cusItem.I && this.checkItemList.cusItem.I.oIncomeLast ) {
        if( '1' === this.checkItemList.cusItem.I.relationOwnerCode) {
          return false
        }
        if (parseFloat(this.checkItemList.cusItem.I.oIncomeLast) !== parseFloat(this.checkItemList.cusItem.I.oIncome)){
          return true
        }
      }
      this.checkItemList.cusItem.I.oIncomeReason = ''
      return false
    },
    needHInComeIReason () {
      if (this.checkItemList.cusItem.I && this.checkItemList.cusItem.I.hIncomeLast ) {
        if( '1' === this.checkItemList.cusItem.I.relationOwnerCode) {
          return false
        }
        if (parseFloat(this.checkItemList.cusItem.I.hIncomeLast) !== parseFloat(this.checkItemList.cusItem.I.hIncome)){
          return true
        }
      }
      this.checkItemList.cusItem.I.hIncomeReason = ''
      return false
    },
    needAssetsIReason () {
      if (this.checkItemList.cusItem.I && this.checkItemList.cusItem.I.assetsLast ) {
        if( '1' === this.checkItemList.cusItem.I.relationOwnerCode) {
          return false
        }
        if (parseFloat(this.checkItemList.cusItem.I.assetsLast) !== (parseFloat(this.checkItemList.cusItem.I.pp) + parseFloat(this.checkItemList.cusItem.I.rp))){
          return true
        }
      }
      this.checkItemList.cusItem.I.assetsReason = ''
      return false
    }
  }
}
</script>
